// @flow
// @ jsx h

import { h, Component } from "preact";
import { Text } from "preact-i18n";
import Link from "../../link";
import { ArrowLeftIcon } from "elc-icons";

import { ThemeConfig, withStyles } from "elc-theme";

import styles from "./PiError.scss";

type PiErrorProps = {
  changeLoadingState: any,
  config: WidgetConfig,
  error: string,
};
type PiErrorState = {
  status: string,
};

class PiError extends Component<PiErrorProps, PiErrorState> {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
    };
  }

  componentDidMount() {
    this.props.changeLoadingState();
    // initialise le statut en fonction de l’erreur reçue
    const statusKey = this.getPaymentErrorKey(this.props.error);
    this.setState({ status: statusKey });
  }

  componentDidUpdate(prevProps) {
    // si l’erreur change, on recalcule la clé
    if (prevProps.error !== this.props.error) {
      const statusKey = this.getPaymentErrorKey(this.props.error);
      this.setState({ status: statusKey });
    }
  }
  getPaymentErrorKey = (key) => {
    const errorKeyMap = {
      PAIEMENT_OK: "stripe.paymentIntent.error.PAIEMENT_OK",
      PAIEMENT_EN_COURS: "stripe.paymentIntent.error.PAIEMENT_OK",
      ECHEC_LECTURE_PI: "stripe.paymentIntent.error.ECHEC_LECTURE_PI",
      ECHEC_CANCEL_PI: "stripe.paymentIntent.error.ECHEC_CANCEL_PI",
    };

    return errorKeyMap[key] || "stripe.paymentIntent.error.default";
  };

  render() {
    const { config } = this.props;
    const { status } = this.state;
    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => {
          return (
            <div>
              <div>
                <h2>
                  <Text id={status}>Paiement en cours de traitement</Text>
                </h2>
                <p>
                  {status !== 'stripe.paymentIntent.error.default' && (
                    <Text id="stripe.paymentIntent.error.defaultDetail">
                      Votre paiement est en cours de vérification. S'il aboutit,
                      alors vous recevrez un mail de confirmation
                    </Text>
                  )}
                </p>
                <div>
                  {config &&
                    (config.type === "WIDGET" || config.type === "MYPAGE") && (
                      <Link
                        href={`/${config.module.hash}`}
                        className={styles.newOrderButton}
                      >
                        <ArrowLeftIcon
                          color={
                            themeConfig && themeConfig.color1
                              ? themeConfig.color1
                              : styles.arrowColor
                          }
                        />
                        <Text id="payment.confirmation.newOrder">
                          Pass a new order
                        </Text>
                      </Link>
                    )}
                </div>
              </div>
            </div>
          );
        }}
      </ThemeConfig.Consumer>
    );
  }
}

export default withStyles(PiError, styles);